export enum Vertical {
    HAIR = 'Hair',
    SEX = 'Sex',
    SKIN = 'Skin',
    MENTAL_HEALTH = 'Mental health',
    WEIGHT_LOSS = 'Weight loss',
    PROSTATE = 'Prostate',
    DIABETES = 'Diabetes',
    GENERAL_HEALTH = 'General health',
}

export enum Subvertical {
    PE = 'PE',
    ED = 'ED',
}

export enum BlogCategory {
    MENS_HEALTH = 'Men’s Health',
    WOMENS_HEALTH = 'Women’s Health',
    GENERAL_HEALTH = 'General Health',
    CATEGORY_GUIDES = 'Category Guides',
    INTERESTS = 'Interests',
    NONE = '-',
}

interface VerticalByParam {
    [key: string]: Vertical | undefined;
}

export const verticalByParam: VerticalByParam = {
    hair: Vertical.HAIR,
    'hair-loss': Vertical.HAIR,
    sex: Vertical.SEX,
    skin: Vertical.SKIN,
    'mental-health': Vertical.MENTAL_HEALTH,
    'weight-loss': Vertical.WEIGHT_LOSS,
    prostate: Vertical.PROSTATE,
    diabetes: Vertical.DIABETES,
};
